const getMarketFromQueryParam = (): undefined | string =>
  new URLSearchParams(window.location.search).get('market')?.toLowerCase() ?? undefined;

const getMarketFromPathname = (): undefined | string =>
  window.location.host.includes('audiusa') ? 'us' : 'ca';

const getMarket = (): 'USA' | 'CAN' => {
  const value = getMarketFromQueryParam() ?? getMarketFromPathname();

  if (value?.startsWith('us')) return 'USA';

  return 'CAN';
};

export default getMarket;

export const MARKET = getMarket();
